import styled from 'styled-components';
import { colors } from 'ui/theme';

export const PlaceholderText = styled.div`
  color: ${colors.textSecondary};
`;
